<div class="footer container content">
  <div class="d-inline-block text-center">
    <a href="#" class="h4 font-weight-bolder text-uppercase">Mirko Reichlin</a><br>
    <a href="mailto:hallo@mirkoreichlin.ch">hallo@mirkoreichlin.ch</a><br>
    <a href="https://www.instagram.com/mirkoreichlin/" target="_blank"><i class="bi-instagram"></i></a>
  </div>
</div>
